import React, { Component } from 'react';
import classNames from 'classnames';
import './Page.css';

export default class Page extends Component {
	render() {
		return <div role="main" className={classNames('g-page', this.props.className)}>{this.props.children}</div>;
	}
}



// WEBPACK FOOTER //
// ./src/components/page/Page.jsx